import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=bcc488b6&scoped=true&"
import script from "./activityDetails.vue?vue&type=script&lang=js&"
export * from "./activityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc488b6",
  null
  
)

export default component.exports